module.exports = __webpack_public_path__ + "static/img/examinedetailXZ.d3968fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/examinedetailXZ.jpg
// module id = 5o39
// module chunks = 6